import styled from '@emotion/styled';
import { themeColors } from 'theme/theme.config';

export const SMainContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SContainer = styled.div`
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: ${themeColors.character.title85};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const STitle = styled.div`
  font-weight: 500;
  font-size: 36px;
  line-height: 44px;
  margin-top: 62px;
`;

export const SDescription = styled.div`
  font-size: 20px;
  line-height: 28px;
  margin: 24px 0;
  text-align: center;
`;
